export const initialLayer = { data: null, show: false, isLoading: false };
export const initialHistoric = { data: [], isLoading: false, error: null };
export const emptyPolygon = { feature: null, area: null, vertices: 0, drawing: false };
export const initialPreview = { item: null, data: null, isLoading: false, error: null };